<template>
  <el-dialog
    title="Create a New Curation"
    :visible="shouldShow"
    @close="closeModal"
    width="35%"
  >
    <el-form :model="form" label-position="top">
      <el-row>
        <el-col>
          <el-form-item label="Curation Name" prop="name">
            <el-input
              class=""
              v-model="searchQuery"
              type="text"
              placeholder="Search"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="Business Category" prop="category">
            <el-select
              v-model="businessType"
              :loading="loading"
            >
              <el-option
                v-for="item in list"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :span="12">
          <el-form-item label="Start Date (Optional)" prop="start">
            <el-date-picker
              v-model="form.dateRange.start"
              type="date"
              placeholder="Pick a day"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="End Date (Optional)" prop="end">
            <el-date-picker
              v-model="form.dateRange.end"
              type="date"
              placeholder="Pick a day"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="Description" prop="textarea">
            <el-input
              v-model="form.textarea"
              :rows="4"
              type="textarea"
              placeholder="Please input"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="createCuration" :disabled="false"
        >Create Curation</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },

  data() {
    return {
      form: {
        dateRange: {
          start: "",
          end: "",
          textarea: "",
        },
      },
      businessType: "",
      searchQuery: "",
      loading: false,
      options: [],
      list: ["food", "laundry"],
    };
  },

  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  methods: {
    closeModal() {
      this.shouldShow = false;
    },

    createCuration() {},
  },
};
</script>

<style></style>
